import * as React from 'react';
import classnames from 'classnames';

import { t } from 'utils/language';

type Props = {
  type?: 'plain' | 'placeholder',
  message?: string
};

const DeliverableMediaBlank = (
  {
    type,
    message
  }: Props
): JSX.Element => {
  const classes = classnames({
    'deliverable-media-blank': true,
    [`deliverable-media-blank--type-${String(type)}`]: type
  });

  return (
    <section className={classes}>
      {message || t('deliverable_media.blank_media')}
    </section>
  );
};

DeliverableMediaBlank.defaultProps = {
  type: 'plain'
};

export default DeliverableMediaBlank;
